import { createSlice } from '@reduxjs/toolkit';
import { createAdmin, getAdminEdit, getAdmins, updateAdmin } from './admins.actions';

const initialState = {
  admins: [],
  adminsMeta: {},
  isLoadingAdmins: false,

  selectedAdmin: {},
  isLoadingSelectedAdmin: false,

  errors: {},
};

const adminsSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {
    setAdminsMeta: (state, action) => {
      state.adminsMeta = action.payload;
    },
    setSelectedAdmin: (state, action) => {
      state.selectedAdmin = action.payload;
    },
    setAdminsErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAdmins.pending, (state) => {
      state.isLoadingAdmins = true;
    });
    builder.addCase(getAdmins.fulfilled, (state, action) => {
      state.admins = action.payload;
      state.isLoadingAdmins = false;
    });
    builder.addCase(getAdmins.rejected, (state) => {
      state.isLoadingAdmins = false;
    });

    builder.addCase(createAdmin.pending, (state) => {
      state.isLoadingSelectedAdmin = true;
    });
    builder.addCase(createAdmin.fulfilled, (state) => {
      state.isLoadingSelectedAdmin = false;
    });
    builder.addCase(createAdmin.rejected, (state) => {
      state.isLoadingSelectedAdmin = false;
    });

    builder.addCase(getAdminEdit.pending, (state) => {
      state.isLoadingSelectedAdmin = true;
    });
    builder.addCase(getAdminEdit.fulfilled, (state, action) => {
      state.selectedAdmin = action.payload;
      state.isLoadingSelectedAdmin = false;
    });
    builder.addCase(getAdminEdit.rejected, (state) => {
      state.isLoadingSelectedAdmin = false;
    });

    builder.addCase(updateAdmin.pending, (state) => {
      state.isLoadingSelectedAdmin = true;
    });
    builder.addCase(updateAdmin.fulfilled, (state) => {
      state.isLoadingSelectedAdmin = false;
    });
    builder.addCase(updateAdmin.rejected, (state) => {
      state.isLoadingSelectedAdmin = false;
    });
  },
});

export const { setAdminsMeta, setSelectedAdmin, setAdminsErrors } = adminsSlice.actions;

export default adminsSlice.reducer;
